import {plainTextToEmailHtml} from '../../utils/plainTextToEmailHtml';
import {sanitizeEmailHtml} from '../../utils/sanitizeEmailHtml';
import {spaceProposedParagraphs} from './spaceProposedParagraphs';

/** A rewritten selection keeps the spacing of the text around it; only a whole message is spaced. */
export const prepareProposedBody = (body: string, isHtml: boolean, isSelection = false): string => {
  if (!isHtml) {
    return body;
  }

  const html = sanitizeEmailHtml(plainTextToEmailHtml(body));
  return isSelection ? html : spaceProposedParagraphs(html);
};
